<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <!--醫師簡介維護程式-->
    <v-flex xs12>
        <v-card class="cardBgColorStyle">

            <v-card row wrap dark  color="secondary"  dense style="padding:0px 0px">

                <v-flex  d-inline-flex style="margin-bottom: -5px">
                    <v-btn @click="addItem"  dark fab top right color="accent" class="mb-2 mt-0">
                        <v-icon >mdi-plus</v-icon>
                    </v-btn>
                </v-flex>

                <!--程式名稱-->
                <v-flex d-inline-flex pl-2 style="font-size: 1.2rem;margin-bottom: -5px">
                    {{this.menuInfo.funTitle}}
                </v-flex>

                <v-flex d-inline-flex pl-2>
                    <hismax-date-picker class="inputDate" :edit-type="startDate.editType" :date-type="startDate.dateType" :date-title="startDate.title" :edit-hint="startDate.hint" :edit-date="startDate.editDate" :clearable="startDate.clearable" @datePick="startDatePick"></hismax-date-picker>
                    <v-flex  d-inline-flex pl-2 style="margin-bottom: -5px">
                        <v-radio-group v-model="displayFlag" @change="axios_getDoctorListData(startDate.editDate,displayFlag)" row hide-details >
                            <v-radio label="Menu查詢" value='Y' ></v-radio>
                            <v-radio label="彈出視窗" value='P' ></v-radio>
                            <v-radio label="隱藏" value='N' ></v-radio>
                            <v-radio label="全部" value='ALL' ></v-radio>
                        </v-radio-group>
                    </v-flex>
                    <v-btn  middle class="pl-1 pr-1 ml-2 mt-3 regFRBtn" @click="axios_getDoctorListData(startDate.editDate,displayFlag)">查詢</v-btn>
                </v-flex>



                <!--<v-flex xs12 sm6 md4 d-inline-flex pl-2>-->
                <!--<v-switch color="white" class="mr-2"  style="float: right" hide-details  :label="`${effFlag==true?'有效資料':'全部資料'}`" v-model="effFlag"></v-switch>-->
                <!--</v-flex>-->




            </v-card>



            <v-flex style="padding-top:1rem">
                <v-data-table
                        dense
                        :search="search"
                        id="funListTable"
                        :loading="funListLoading"
                        :headers="funListHeaders"
                        :items="doctorList"
                        @page-count="pagination.pageCount = $event"
                        :page.sync="pagination.page"
                        :sort-by="pagination.sortBy"
                        :sort-desc="pagination.descending"
                        :loading-text="loadingText"
                        :items-per-page="pagination.rowsPerPage"
                        hide-default-footer
                        hide-default-header
                        item-key="chart_no"
                        v-resize="resizeFunListGrid"
                        class="elevation-1">

                    <template v-slot:header="{ props }">
                        <tr class="px-1 text-left tablehead">
                            <th v-for="header in props.headers"
                                :key="header.text"
                                :class="['column sortable',pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '','px-1']"
                                @click="changeSort(header.value)">
                                <span  v-html="header.text"></span>
                                <v-icon small
                                        :style="{display:header.value === pagination.sortBy ? pagination.descending ? 'none' : 'inline' : 'none'}">
                                    mdi-arrow-up
                                </v-icon>
                                <v-icon small
                                        :style="{display:header.value === pagination.sortBy ? pagination.descending ? 'inline' : 'none' : 'none'}">
                                    mdi-arrow-down
                                </v-icon>
                            </th>
                        </tr>
                    </template>

                    <template slot="item" slot-scope="props" style="border: 1px solid black">
                        <!--<tr :active="props.selected" @click="props.selected = !props.selected">-->
                        <!--<td>
                          <v-checkbox :input-value="props.selected" primary hide-details></v-checkbox>
                        </td>-->
                        <tr>
                            <td class=" align-space-around justify-space-around fill-height px-0" >
                                <v-layout>
                                    <v-btn icon class="mx-0" @click.native.stop="editItem(props.item)"> <!---->
                                        <v-icon color="tertiary">mdi-pencil</v-icon>
                                    </v-btn>
                                    <v-btn icon class="mx-0" @click.native.stop="deleteItem(props.item)"><!---->
                                        <v-icon color="tertiary">mdi-delete</v-icon>
                                    </v-btn>
                                </v-layout>

                            </td>
                            <td  class="px-1 text-left" style="min-width: 100px">{{transDisplayFlag(props.item.displayFlag)}}</td>
                            <td  class="px-1 text-left" style="min-width: 80px">{{ $UtilityJs.AD2ROC_DateTime(props.item.startDatetime,'showDT')}} </td>
                            <td  class="px-1 text-left" style="min-width: 100px">{{ $UtilityJs.AD2ROC_DateTime(props.item.endDatetime,'showDT')}}</td>

                            <td  class="px-1 text-left" ><img :src="props.item.mainPict" width="150px" /></td>
                            <td  class="px-1 text-left" style="white-space: pre-line" v-html="props.item.content"></td>
                            <td  class="px-1 text-left">{{props.item.createUser}}<br/>{{$UtilityJs.AD2ROC_DateTime(props.item.createDatetime,'showDT')}}</td>
                            <td  class="px-1 text-left" style="min-width: 120px">{{props.item.lastModiUser}}<br/>{{ $UtilityJs.AD2ROC_DateTime(props.item.lastModiDatetime,'showDT')}}</td>



                        </tr>
                    </template>
                    <template slot="pageText" slot-scope="props">
                        第 {{ props.pageStart }} - {{ props.pageStop }} ,共 {{ props.itemsLength }} 筆
                    </template>
                    <template slot="no-data">

                        <v-alert :value='countDownNo>=5' type="warning" icon="mdi-alert-circle">
                            查詢中...
                        </v-alert>
                        <v-alert :value='tableAlert' color="info" icon="mdi-information">
                            表格中沒有內容
                        </v-alert>

                    </template>
                    <!--<v-alert slot="no-results" :value="true" color="info" icon="mdi-alert-circle">-->
                    <!--Your search for " {{ search }} " found no results.-->
                    <!--</v-alert>-->
                </v-data-table>
                <v-layout row wrap>
                    <v-flex xs12 md2>
                        <v-text-field
                                v-model="search"
                                class="ml-2 mt-2"
                                prepend-inner-icon="mdi-magnify"
                                single-line
                                hide-details
                                clearable
                        ></v-text-field>
                    </v-flex>


                    <v-flex xs12 md6 text-center pt-2>
                        <v-pagination color="accent" v-model="pagination.page" :length="pagination.pageCount" :total-visible="7"></v-pagination>
                    </v-flex>
                    <v-flex xs6 md2 pt-2 pr-2 pl-2>
                        <v-select
                                :items="pageItem"
                                label="每頁筆數"
                                item-value="value"
                                v-model="pagination.rowsPerPage"
                        ></v-select>
                    </v-flex>
                    <v-flex xs6 md2 text-left pt-2 pr-2>
                        <v-text-field
                                label="總筆數"
                                v-model="doctorList.length"
                                readonly
                        ></v-text-field>
                    </v-flex>
                </v-layout>

            </v-flex>



        </v-card>



        <v-dialog v-model="editDialog"
                  eager
                  xs6 sm6 md6
                  :width="editDialogWidth+'%'"
                  value="false"
                  scrollable>
            <edit-news   :is-show="editDialog" @closeDialog="closeDialog" @save="save" :edit-index="editIndex" :edit-obj="editObj"></edit-news>
        </v-dialog>

        <v-dialog v-model="deleteDialog"
                  width="50%"
                  xs6 sm6 md6
                  value="false"
                  scrollable>
            <delete-info-dialog @closeDelete="closeDelete" @confirmDelete="confirmDelete" :delete-title="deleteTitle" :delete-content="deleteContent"></delete-info-dialog>
        </v-dialog>

        <!-- 我是 snackbar -->
        <v-snackbar
                :timeout="snTimeout"
                v-model="snStatus">
            {{snText}}
        </v-snackbar>


    </v-flex>
</template>

<script>
    import EditNews from './EditNews'
    import DeleteInfoDialog from '../inursingsys/DeleteInfoDialog'
    import HismaxDatePicker from '../utility/HismaxDatePicker'
    export default {
        name: "NewsMaintain",
        components: { DeleteInfoDialog,EditNews,HismaxDatePicker},
        data() {
            return {
                displayFlag:'Y',
                startDate:{
                    title:'有效日期',
                    hint:'',
                    editDate:'',
                    clearable:false,
                    dateType:'date',
                    editType:'menu'
                },
                zone:'A',//院區
                //程式功能清單
                countDownId: null, //data 定義一個定時器id
                countDownNo:0,
                tableAlert:false,
                effFlag:true,
                funListLoading:false,
                loadingText:'查詢中...',
                search:'',
                snTimeout:4000,
                snStatus:false,
                snText:'',
                deleteDialog:false,
                deleteTitle:'刪除 News',
                deleteContent:'',
                deleteObj:{},
                editDialog:false,
                editIndex:-1,
                editObj:{},
                doctorList: [],
                systemId:'',
                divNo:'',
                pagination: {
                    sortBy: 'dataType',
                    rowsPerPage:100,
                    page: 1,
                    pageCount: 0,
                    descending:false
                },
                pageItem:[
                    {text:100,value:100},
                    {text:20,value:20},
                    {text:"All",value:-1},
                ],
                pageText:'每頁筆數 :',
                funListHeaders:[
                    {
                        text: '',
                        align: 'center',
                        // value: 'assessDate'
                    },
                    {
                        text: '顯示類型',
                        // align: 'center',
                        value: 'displayFlag',
                        class:'px-1'
                    },
                    {
                        text: '開始日期',
                        // align: 'left',
                        value: 'startDatetime',
                        class:'px-1'
                    },
                    {
                        text: '結束日期',
                        // align: 'center',
                        value: 'endDatetime',
                        class:'px-1'
                    },
                    {
                        text: '主影像',
                        // align: 'center',
                        value: 'mainPict',
                        class:'px-1'
                    },
                    {
                        text: '內文',
                        // align: 'center',
                        value: 'content',
                        class:'px-1'
                    },
                    {
                        text: '建立日期/人員',
                        // align: 'left',
                        value: 'createDatetime',
                        class:'px-1'
                    },
                    {
                        text: '最近修改日期/人員',
                        // align: 'left',
                        value: 'lastModiDatetime',
                        class:'px-1'
                    },

                ]
            }
        },
        created(){
            let today = this.$UtilityJs.AD2ROC_DateTime(new Date().toISOString(),'date');
            this.startDate.editDate = today;
            this.axios_getDoctorListData(this.startDate.editDate,this.displayFlag)

        },
        computed:{
            menuInfo() {
                return this.$store.state.menuInfo;
            },

            editDialogWidth(){ //隨畫面大小 調整Dialog的寬度
                let width = 50;
                if (this.$vuetify.breakpoint.xs == true) {width = 100 }
                if(this.$vuetify.breakpoint.sm == true){width = 97}
                if(this.$vuetify.breakpoint.md == true){width =  60}
                if(this.$vuetify.breakpoint.lg == true){width =  50}
                if(this.$vuetify.breakpoint.xl ==true){width =  40}
                return width
            },
        },
        watch:{
        },
        methods:{
            transDisplayFlag(flag){
                let str= '';
                switch (flag){
                    case 'Y':
                       str = 'Menu查詢';
                       break;
                    case 'P':
                        str = '彈出視窗';
                        break;
                    case 'N':
                        str = '隱藏';
                        break;
                    default:
                }
              return str;
            },
            startDatePick(item){
                this.startDate.editDate = item;
            },
            divItemText: item => item.divNo==''?'':item.divNo + '-' + item.divName, //格式化 autocomplete 選權限顯示文字
            countDown(){
                if(this.countDownId != null ) return;
                this.countDownId = setInterval(() => {
                    this.countDownNo++
                },1000)
            },
            //停止計時器
            stopCountDown(){
                clearInterval(this.countDownId);
                //當我清除定時器之後，重新讓countDownId為null , countDownNo歸零
                this.countDownId = null;
                this.countDownNo=0;
            },
            changeSort: function(column) {
                // console.log(column);
                if (this.pagination.sortBy === column) {
                    this.pagination.descending = !this.pagination.descending
                } else {
                    this.pagination.sortBy = column;
                    this.pagination.descending = false
                }
            },
            closeDelete(){
                this.deleteDialog = false;

            },
            confirmDelete(){
                this.axios_deleteDoctor(this.deleteObj);
            },
            transformUTC(utc,flag){ //uct->Date ; flag-> all,date,time
                let date =  this.$UtilityJs.AD2ROC_DateTime(utc,flag);
                return (date)
            },
            addItem(){  //新增按鈕
                this.editDialog = true;
                this.editIndex = -1;
            },
            closeDialog(){ //關閉編輯視窗
                this.editDialog = false;
            },
            editItem:function(item){
                this.editIndex = this.doctorList.indexOf(item);
                this.editObj = item;
                this.editDialog = true;
            },
            deleteItem:function(item){  //刪除
                this.deleteObj = item;
                this.deleteDialog = true;
                this.deleteContent = '確定要刪除，[建立日期 '+this.$UtilityJs.AD2ROC_DateTime(item.createDatetime,'all')+"]的記錄";
            },
            save(item){
                if(this.editIndex==-1){ //新增
                    this.axios_postDoctor(item);
                }else { //修改
                    this.axios_putDoctor(item);
                }
            },
            resizeFunListGrid:function(){
                var userHeight = window.innerHeight
                    || document.documentElement.clientHeight
                    || document.body.clientHeight;
                let height = userHeight-(270);
                let funListTable = document.getElementById('funListTable');
                funListTable.setAttribute('style','overflow-y: auto;min-height:'+height+'px;max-height:'+height+'px;');
            },
            axios_getDoctorListData (date,displayFlag){ //查詢醫師簡介全部清單
                this.countDown();//開始計時
                this.funListLoading = true;
                this.tableAlert = false;
                this.doctorList = [];
                let start = date.replace(new RegExp("-","gm"),"");
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "news/datasearch/bydatedisplayflag/"+start+"/"+displayFlag;

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.doctorList = response.data.resultSet;

                    }else{
                        this.tableAlert = true;
                        this.doctorList = [];
                    }
                    this.funListLoading = false;
                    this.stopCountDown();
                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                        this.doctorList = [];
                    } catch(err) {
                        this.doctorList = [];
                    }
                    this.funListLoading = false;
                    this.stopCountDown();
                });
            },

            axios_postDoctor(postData){ //新增 醫師簡介
                let postList = [];
                postList.push(postData);
                // let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "news/";

                this.$http.post(url,postList).then(response=>{
                    this.snStatus=true;
                    this.snText = response.data.message;
                    if(response.data.resultSet.length>0&& response.data.hasOwnProperty('resultSet')){
                        this.editDialog = false;
                        this.axios_getDoctorListData(this.startDate.editDate,this.displayFlag);


                        // this.search = response.data.resultSet[0].dataType
                    }
                    this.snText = response.data.message;
                }).catch(error =>{
                    try{
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }catch (e) {
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }
                });
            },
            axios_putDoctor(putData){ //修改 醫師簡介
                let postList = [];
                postList.push(putData);
                // let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "news/";

                this.$http.put(url,postList).then(response=>{
                    this.snStatus=true;
                    this.snText = response.data.message;
                    if(response.data.resultSet.length>0){
                        this.editDialog = false;
                        this.axios_getDoctorListData(this.startDate.editDate,this.displayFlag);

                    }
                }).catch(error =>{
                    try{
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }catch (e) {
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }
                });
            },
            axios_deleteDoctor(item){   //刪除單筆資料
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "news/s/"+item.rawPk;

                this.$http.delete(url).then(response=>{
                    this.snStatus=true;
                    this.snText = response.data.message;
                    if(response.data.resultSet.length>0){
                        this.axios_getDoctorListData(this.startDate.editDate,this.displayFlag);
                        this.deleteDialog = false;
                    }

                }).catch(error =>{
                    try{
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }catch (e) {
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }
                });
            },

        }
    }
</script>

<style scoped>

    .cardBgColorStyle{
        padding:0px 10px;
        background-color: rgba(255,255,255,1);
    }

    .labelFont{
        line-height: 62px;
    }


</style>